// src/Redux/Sidebar/actions.js
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});